import { Card, Grid, Typography } from '@mui/material';
import DashboardStatListCard from './DashboardStatListCard';



function DashboardKurulMeetingsCard({ countList }) {


    return (

        <Card
            sx={{
                backgroundColor: '#FFFFFF',
                borderRadius: '8px',
                boxShadow: 2,
                padding: '10px',
                minHeight: '190px'
            }}
        >
            <Typography
                variant='h6'
                sx={{ padding: '5px' }}
            >
                Kurul - Komisyon Yetkili Olduğunuz Toplantılar
            </Typography>
            <Grid container spacing={1} direction="row">
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"allFinish"} />
                </Grid>
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"allOngoing"} />
                </Grid>
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"admin"} />
                </Grid>
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"review"} />
                </Grid>
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"video"} />
                </Grid>
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"vote"} />
                </Grid>
            </Grid>
        </Card>

    );
}

export default DashboardKurulMeetingsCard;